import { render, staticRenderFns } from "./JcRecordModal.vue?vue&type=template&id=23da7e93&scoped=true"
import script from "./JcRecordModal.vue?vue&type=script&lang=js"
export * from "./JcRecordModal.vue?vue&type=script&lang=js"
import style0 from "./JcRecordModal.vue?vue&type=style&index=0&id=23da7e93&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23da7e93",
  null
  
)

export default component.exports